<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <span style="font-size:45px;font-weight:bold;color:white;line-height:normal;" class="mb-0">
          Administrar usuarios
          <!-- <v-subheader dark class="">Mostrando 5 usuarios</v-subheader> -->
        </span>
        <div style="font-size:14px;font-weight:300;color:white;">
          Mostrando 5 usuarios

        </div>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card class="strategio-card-container">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <!-- <v-flex class="strategio-user-admin-sub-division" xs12 sm12 md12 lg12 xl12>
                  Administrar usuarios
                  <v-subheader>Mostrando {{users.length}} usuarios</v-subheader>
                </v-flex> -->
                <v-flex xs12>
                  <v-form id="usersfilter-textfield" @submit.prevent="search()">
                    <v-text-field
                      id="txtBuscar"
                      name="txtBuscar"
                      label="Buscar por nombre, cargo o correo"
                      prepend-icon="search"
                      clearable
                      autocomplete="off"
                    ></v-text-field>
                  </v-form>
                </v-flex>
                <v-container class="pa-0">
                  <v-list>
                    <div v-for="(u, $index) in users" :key="$index">
                      <v-divider v-if="$index !== 0"></v-divider>
                      <users-list-item :id="'userlistitem' + $index" :user-data="u"></users-list-item>
                    </div>
                  </v-list>
                </v-container>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import adminStorage from '../../storage/adminStorage'
import UsersListItem from '../users/users-list-item.vue'
import filter from 'lodash/filter'
import eventBus from '../../utils/eventBus'

let usersData = []

export default {
  name: 'users-list',
  data () {
    return {
      users: []
    }
  },
  mounted () {
    adminStorage.getAdminUsers({
      onSuccess: (data) => {
        usersData = data.map((d) => {
          d.mail = d.mail ? d.mail.toUpperCase() : ''
          d.name = d.name ? d.name.toUpperCase() : ''
          d.description = d.description ? d.description.toUpperCase() : ''
          return d
        })
        this.users = JSON.parse(JSON.stringify(usersData))

        // emits to: /components/header-bar/strategio-app-bar.vue
        eventBus.$emit('enable-tutorial-button')
      },
      onError: (error) => {
        console.warn('Error obteniendo usuarios', error)
        eventBus.$emit('open-custom-snack-bar', {message: 'Ha habido un problema con el servidor', itsOk: false})
      }
    })
  },
  methods: {
    search () {
      const q = document.getElementById('txtBuscar').value.trim().toUpperCase()
      const qq = filter(usersData,
        u => u.mail.toUpperCase().indexOf(q) > -1 ||
            u.name.toUpperCase().indexOf(q) > -1 ||
            u.description.toUpperCase().indexOf(q) > -1 ||
            u.userType.toUpperCase().indexOf(q) > -1
      )
      console.log(qq)
      this.users = qq
    }
  },
  components: {
    UsersListItem
  }
}
</script>

<style>
.strategio-user-admin-sub-division {
  font-size: 24px;
  font-weight: 300;
  margin-top: 24px;
  margin-bottom: 8px;
}
</style>




// WEBPACK FOOTER //
// src/components/users/users-list.vue